import { createEntityByIdSource } from 'serviceWorker/channelServers/entitySource';
import * as dbLevels from 'serviceWorker/db/levels/levels';
import * as dbLevelsService from 'serviceWorker/db/levels/levelsService';
import { levelEntityToModel } from 'serviceWorker/repository/level/mappings';
import { getCurrentUsers } from 'serviceWorker/services/users/getUsers';
import { levelContract } from 'shared/domain/level/levelContract';
import { levelsSync } from './index';

/** Levels of IndexedDB, with the users downloaded so far (a missing users download must not block them). */
export const levelSource = createEntityByIdSource({
  service: dbLevelsService,
  contract: levelContract,
  ...levelsSync,
  readAll: async () => {
    const [levels, users] = await Promise.all([dbLevels.get(), getCurrentUsers()]);
    return levels.map((level) => levelEntityToModel(level, users));
  },
  readOne: async (id) => {
    const [level, users] = await Promise.all([dbLevels.getOne(id), getCurrentUsers()]);
    return level && levelEntityToModel(level, users);
  },
});
